import { HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigGlobal } from './interfaces/config-global.interfaces';
import { RTCConfig } from './interfaces/webrtc/rtc-config.interface';

@Injectable()
export class Globals {
  version = '0.0.0';
  appOrigin = '';
  logRoot = '';
  apiRoot = '';
  imageRoot = '';
  server = '';
  calendar = '';
  semsaWizardUrl = '';
  lqsboxWizardUrl = '';
  admin = false;
  sonosClientId = '';
  shouldCache = false;
  isUbieTouch = false;
  linkRoot = '';
  googleMapsApiKey = '';
  publishers: any = [];
  rtcConfig: RTCConfig = { iceServers: [] };

  constructor() {
    const config = inject<ConfigGlobal>('config' as any);

    this.version = config.version;
    this.appOrigin = config.appOrigin;
    this.logRoot = config.logRoot;
    this.apiRoot = config.apiRoot;
    this.imageRoot = config.imageRoot;
    this.server = config.server;
    this.calendar = config.calendar;

    this.linkRoot = config.linkRoot;

    this.semsaWizardUrl = config.semsaWizardUrl;
    this.lqsboxWizardUrl = config.lqsboxWizardUrl;

    this.admin = config.admin ?? false;
    this.sonosClientId = config.sonosClientId;

    this.shouldCache = config.shouldCache ?? false;
    this.publishers = config.publishers;
    this.isUbieTouch = config.isUbieTouch ?? false;
    this.rtcConfig = config.rtcConfig ?? { iceServers: [] };

    if (config.googleMapsApiKey) {
      this.googleMapsApiKey = config.googleMapsApiKey;
    }
  }

  localStorageTokenName = 'currentUser';

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  // path of .net mail html template
  mailSource = 'IDB';

  createImageUrl(path: string) {
    return `${this.imageRoot}${path}`;
  }
}
